import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isEnableFwaRedesignFFlag } from '../../../../components/common/Helpers';

const addons = Loadable(() => (
  isEnableFwaRedesignFFlag()
    ? import('../../../PerksAndServices')
    : import('../../containers/web/addons')
));

export default MapTo('vcg/components/soe-home/react/addons')(addons);
